import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { getIsMobile } from './getIsMobile';
import type { Location } from '@remix-run/router';

const storage: Record<string, number> = {};

type UseScrollRestorationProps = {
    buildLocationKey: (location: Location) => string;
};

export const useScrollRestoration = (props: UseScrollRestorationProps) => {
    const { buildLocationKey } = props;
    const location = useLocation();
    const isMobile = getIsMobile();

    useEffect(() => {
        if (location.state?.dialogName || isMobile) {
            return () => {};
        }

        const key = buildLocationKey(location);

        const onWindowScroll = () => {
            storage[key] = window.scrollY;
        };

        window.scrollTo({ top: storage[key] ?? 0 });
        setTimeout(() => {
            window.scrollTo({ top: storage[key] ?? 0 });
        }, 0);

        window.addEventListener('scroll', onWindowScroll, { passive: true });

        return () => window.removeEventListener('scroll', onWindowScroll);
    }, [location, isMobile]);
};
